<template>
  <v-app>
    <v-app-bar
      app
      color="#B30B0B"
      dark
      dense
      v-if="getLogeado"
      class ="ma-5 mt-3" 
      style="border-radius: 10px;"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      Sistema de administración
      <v-spacer></v-spacer>
      <v-btn text icon v-if="getLogeado" @click="salir"><v-icon>mdi-exit-to-app</v-icon></v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <!-- Menu lateral izquierdo -->
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      v-if="getLogeado"
      class="elevation-3 mt-3 pb-5"
      style="border-radius: 10px;"
    >

      <v-list-item class="pt-4 px-1" >
        <v-list-item-content>
          <v-img src="" v-if="!mini"></v-img>
          <v-avatar
            size="40"
            v-else="mini"
            color="white"
          >
            <img src="">
          </v-avatar>
        </v-list-item-content>

        <v-btn icon @click.stop="mini = !mini" color="primary">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item class="px-2" @click="verMiPerfil( )">
        <v-list-item-avatar>
          <v-img
            :src="avatar"
          ></v-img>
        </v-list-item-avatar>

        <v-list-item-content v-if="getdatosUsuario">
          <v-list-item-title>
            {{ getdatosUsuario.nomuser }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ getdatosUsuario.puesto }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav class="mr-0">
        <v-list-group
          v-for="item in menu"
          :key="item.title"
          v-model="item.active"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            color="primary"
            v-for="child in item.subemnu"
            :key="child.title"
            :to="{ name: child.path }"
            :class="`pl-2 ${ child.color ? child.color : 'grey lighten-3' }`"
          >

            <v-list-item-icon>
              <v-icon color="primary">mdi mdi-circle-medium theme--light</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <!-- REGLAMENTO -->
      <v-list dense nav class="mr-0">
        <v-list-item @click="salir" class="red white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      


    </v-navigation-drawer>

  </v-app>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    name: 'App',

    components: {
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({
      //
      model: null,
      dialog: false,
      draw: false,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      radio:1,
      drawer: true,
      drawer2:false,
      mini:false,

      accesos: []
     
    }),

    created( ){
      this.initialize()
    },

    methods:{
      ...mapActions('login',['salirLogin']),

      salir(){
        this.salirLogin()
        this.$router.push({name:'login'})
      },

      initialize () {
        this.usuarios = []
        this.cargar = true
        this.$http.get('accesos.all').then(response=>{
          this.accesos = response.body
        }).catch(error=>{this.cargar = false})
      },

      verMiPerfil( ){

        this.$router.push({
          name: 'MiPerfil'
        })

      },
    },

    computed:{
      ...mapGetters('login',['getdatosUsuario','getLogeado']),

      avatar(){
        return "https://ui-avatars.com/api/?background=B30B0B&color=fff&rounded=true&format=svg&name=" + this.getdatosUsuario.nomuser
      },

      accesoWataje( ){
        const existenAccesos = this.accesos.find( el => el.id == this.getdatosUsuario.id )

        let permisos = existenAccesos ? existenAccesos.accesos : []

        return permisos.find( el => el.idruta == 3 )
      },

      menu(){


        return this.getdatosUsuario.menu

        const existenAccesos = this.accesos.find( el => el.id == this.getdatosUsuario.id )

        let permisos = existenAccesos ? existenAccesos.accesos : []


        let menuContext = []


        menuContext.push({ 
          title: "Rutas y Usuarios",
          icon: "mdi-account", 
          items:[
            { title: "Rutas"         , icon: "mdi-account"             , name: "Rutas"          , permisos: ['ADMIN'] },
            { title: "Accesos"       , icon: "mdi-account"             , name: "Accesos"        , permisos: ['ADMIN'] },
            { title: "Usuarios"      , icon: "mdi-account"             , name: "Usuarios"       , permisos: ['ADMIN'] },
            { title: "Departamentos" , icon: "mdi-account"             , name: "Departamentos"  , permisos: ['ADMIN'] },
            { title: "Puestos"       , icon: "mdi-account"             , name: "Puestos"        , permisos: ['ADMIN'] },
            { title: "Jerarquias"    , icon: "mdi-account"             , name: "Jerarquias"     , permisos: ['ADMIN'] },
          ]      
        })


        menuContext.push({ 
          title: "Reloj Checador",
          icon: "mdi-account", 
          items:[
            { title: "Mi Reloj Checador"      , icon: "mdi-account"             , name: "MiRelojChecador"        , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
            { title: "Reloj Checador"         , icon: "mdi-account"             , name: "RelojChecador"          , permisos: ['ADMIN','SUPERVISOR'] },
            { title: "Mis Vacaciones"         , icon: "mdi-account"             , name: "SolicitarVacaciones"    , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
            { title: "Vacaciones Empleado"    , icon: "mdi-account"             , name: "VacacionesEmpleados"    , permisos: ['ADMIN','SUPERVISOR'] },
            { title: "Reporte Vacaciones"     , icon: "mdi-account"             , name: "ReporteVacaciones"      , permisos: ['ADMIN','SUPERVISOR'] },
            { title: "Mis justificaciones"    , icon: "mdi-account"             , name: "MisJustificaciones"     , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
          ]      
        })


        if( permisos.find( el => el.idruta == 2 ) ){

          menuContext.push({ 
            title: "Cotizador", 
            icon: "mdi-account", 
            items:[
              { title: "Artículos"      , icon: "mdi-account"             , name: "Articulos"      , permisos: ['ADMIN'] },
              { title: "Unidades"       , icon: "mdi-account"             , name: "Unidades"       , permisos: ['ADMIN'] },
              { title: "Categorías"     , icon: "mdi-account"             , name: "Categorias"     , permisos: ['ADMIN'] },
              { title: "Cotizador"      , icon: "mdi-account"             , name: "Cotizador"      , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
              { title: "Historial"      , icon: "mdi-account"             , name: "Historial"      , permisos: ['ADMIN','SUPERVISOR'] },
            ]     
          })

        }


        if( permisos.find( el => el.idruta == 4 ) ){

          menuContext.push({ 
            title: "Corte de caja", 
            icon: "mdi-account", 
            items:[
              { title: "Corte de caja"        , icon: "mdi-account"             , name: "corte"         , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
              { title: "Reporte día usuario"  , icon: "mdi-account"             , name: "dia"           , permisos: ['ADMIN'] },
              { title: "Reporte día"          , icon: "mdi-account"             , name: "mes"           , permisos: ['ADMIN'] },
              { title: "Cajas abiertas"       , icon: "mdi-account"             , name: "Estatuscaja"   , permisos: ['ADMIN'] },
            ]      
          })

        }


        if( permisos.find( el => el.idruta == 5 ) ){

          menuContext.push({ 
            title: "Formatos ISO", 
            icon: "mdi-account", 
            items:[
              { title: "Formatos"        , icon: "mdi-account"             , name: "Formatos"      , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
            ]      
          })

        }

        if( permisos.find( el => el.idruta == 6 ) ){

          menuContext.push({ 
            title: "Admin Archivos", 
            icon: "mdi-account", 
            items:[
              { title: "Carpetas"        , icon: "mdi-account"             , name: "Carpetas"             , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
              { title: "Accesos"         , icon: "mdi-account"             , name: "AdministrarAccesos"   , permisos: ['ADMIN','SUPERVISOR'] },
            ]      
          })

        }


        if( permisos.find( el => el.idruta == 7 ) ){

          menuContext.push({ 
            title: "Requisiciones", 
            icon: "mdi-account", 
            items:[
              { title: "Usuarios"            , icon: "mdi-account"             , name: "UsuariosRequi"              , permisos: ['ADMIN'] },
              { title: "Requisiciones"       , icon: "mdi-account"             , name: "Requisiciones"              , permisos: ['ADMIN'] },
              { title: "Mis requisiciones"   , icon: "mdi-account"             , name: "MisRequisiciones"           , permisos: ['ADMIN','USUARIO','SUPERVISOR'] },
              { title: "Requisiciones Depa"  , icon: "mdi-account"             , name: "RequisicionesDepartamento"  , permisos: ['SUPERVISOR'] },
            ]      
          })

        }

        return menuContext

        return [
          { 
            title: "Wataje", 
            icon: "mdi-account", 
            items:[
            ]      
          },
        ]
      }
    }
  };
</script>
<style>

  main{
    background: #f8f9fa ;
  }

  .v-navigation-drawer__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-navigation-drawer__content::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-button:increment,.v-navigation-drawer__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  html{
    background: #f8f9fa;
  }

  .v-main__wrap{
    background: #f8f9fa !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }


  .subrayado {
    text-decoration: underline;
  }

  #idScrollApp::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #idScrollApp::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-button:increment,#idScrollApp::-webkit-scrollbar-button{
    display: none;
  }

  #idScrollApp::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  a .v-list-item .v-list-item--link .theme--light{
    padding-left: 0px !important;
  }

</style>